import React from "react";
import { Text as NativeText, } from "react-native";
import { styles } from "./Text.styles";
import { theme } from "../../theme";
import { getColorFromVariantKey, } from "@clearabee/ui-library-base";
export const Text = ({ fontSize = "base", styles: userStyles, color, ...rest }) => {
    const colorHex = color ? getColorFromVariantKey(color) : undefined;
    return (React.createElement(NativeText, { accessibilityRole: "text", style: [
            styles.defaults,
            theme.fontDefaults[fontSize],
            userStyles,
            !!colorHex && { color: colorHex },
        ], ...rest }));
};
//# sourceMappingURL=Text.js.map